import { Component, OnInit } from '@angular/core';
import { ApiService } from '../shared/api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Dailyverses} from '../models/dailyverses';
import {Router} from '@angular/router';
declare const $: any;

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.css']
})
export class TutorialComponent implements OnInit {
  response : any=[]
  dailyverse : Dailyverses = new Dailyverses();
  constructor(private api: ApiService,public _sanitizer: DomSanitizer, private router:Router) { }

  ngOnInit(): void {
    this.getDailyVerse();
  }
  getDailyVerse()
  {
    this.api.get("/api/enabledailyverse").subscribe((response: any) => {
        this.dailyverse = response
      }
    )
  }
  ImageURL() {
    return this._sanitizer.bypassSecurityTrustResourceUrl(this.dailyverse.URL);
  }

  VideoURLAndroid() {
    return this._sanitizer.bypassSecurityTrustResourceUrl("https://www.mediafire.com/file/2ug33stsm5xceke/END+Android.mov/file");
  }

  VideoURLiPhone() {
    return this._sanitizer.bypassSecurityTrustResourceUrl("https://www.mediafire.com/file/x3gdnbzc5cjq28q/END+IPHONE.mov/file");
  }

  redirected() {
    this.router.navigate(['/home']);
  }

  isNotMobileMenu() {
    if ($(window).width() > 991) {
        return true;
    }
    return false;
  };
  isMobile() {
    if ($(window).width() > 460) {
        return true;
    }
    
    return false;
  };

}
